import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Row, Col, Button, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAmusementService from "../../../core/api/api.amusementService";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { Calendar, DateObject } from 'react-multi-date-picker';
import { persian, customLocale } from "../_Components/customLocale";
import weekends from "react-multi-date-picker/plugins/highlight_weekends"
import moment from "moment-jalaali";
import TreeItem from '@mui/lab/TreeItem';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { tools } from "../../../core/utils/tools";
// Groupby Select React = > https://codesandbox.io/s/9gmd8?file=/src/App.js:1420-1434
const CreateEditAmusementServiceDate = (props) => {
  const [inputValue, setInputValue] = useState('');
  const onInputChange = (str, { action }) => {
    // Prevents resetting our input after option has been selected
    if (action === "set-value") return false;
    setInputValue(str);
  };
  const filterOption = ({ label, value }, string) => {
    if (value === "all") {
      return true;
    } else if (string) {
      return label.includes(string) || value.toString().includes(string);
    } else {
      return true;
    }
  };
  const { register, handleSubmit, control, formState: { errors, isSubmitting }, reset, getValues, setValue } = useForm({
    defaultValues: {
      id: 0,
      selectedDates: [],
      minimumDate: {}
    }
  });

  const useStyles = styled({
    root: {
      padding: '1px 10px',
      width: 'auto',
      display: 'inline-block',
      // height: 110,
      // flexGrow: 1,
      // maxWidth: 400,
    },
    checkbox: {
      "&.MuiCheckbox-root": {
        color: "rgba(81, 185, 201, 0.8)"
      },
      "&.MuiCheckbox-colorSecondary": {
        "&.Mui-checked": {
          color: "rgba(160, 81, 201, 1)"
        }
      }
    },
    text: {
      color: "red"
    }
  });
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const classes = useStyles();
  const [treeViewData, setTreeViewData] = useState({});
  const { match } = props;
  // let params = match.params;
  const [allAmusementServiceList, setAllAmusementServiceList] = useState([]);
  // const [selectedNode, setSelectedNode] = useState({ id: null, name: "", type: "" });
  // const [selectedShowNode, setSelectedShowNode] = useState({ id: null });
  const [selected, setSelected] = useState([]);
  const [dateNow, setdataNow] = useState([]);
  const [groupByAmuzmentService, setgroupByAmuzmentService] = useState([{ label: "Select all", options: "all" }]);


  useEffect(() => {
    (async () => {
      try {
        const apiData = await ApiAmusementService.getAllServices();
        // let datesplit = moment().format("jYYYY/jM/jD").split("/");
        // let minimumDateV = {
        //   year: parseInt(datesplit[0]),
        //   month: parseInt(datesplit[1]),
        //   day: parseInt(datesplit[2])
        // };
        setValue("minimumDate", new DateObject({ calendar: persian }));

        if (!_.isEmpty(apiData)) {
          setAllAmusementServiceList(apiData);
          var grouped = tools.groupByListBasketItem(apiData, "amusementGroupS");
          let objDataListGroupby = []
          let itemLevel = [];
          Object.keys(grouped).map((element) => {
            itemLevel = []
            let yy = grouped[element]?.map((item) => {

              //if (item.reserveDetails != 'NULL') {
              itemLevel.push(
                {
                  value: item.id,
                  label: item.name,
                  // serviceId: JSON.parse(item.reserveDetails)?.Id
                })
              //}
            }
            )
            objDataListGroupby.push({ label: element, options: itemLevel });

          })
          setgroupByAmuzmentService(objDataListGroupby);
        } else {
          setAllAmusementServiceList([]);
        }

      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => { };
  }, []);


  function convertDate(date) {
    let ff = [];
    let tt = date?.map(item => {
      let shamsidateConvert = (item.year + "/" + (item.month < 10 ? ("0" + item.month) : item.month) + "/" + (item.day < 10 ? "0" + item.day : item.day));
      ff.push(
        {
          shamsiData: shamsidateConvert,
          gregorianDate: moment(shamsidateConvert, "jYYYY/jM/jD").format("YYYY-M-D")
        })

    })

    return ff;
  }
  const onSubmit = async (data) => {
    try {
      data.selectedDates = convertDate(data.selectedDates);
      data.amusementserviceListId = selected;
      /*         if (_.isUndefined( data.selectedDates  ) || _.isEmpty(data.selectedDates)){
                SwalMessage({ title: "لطفا تاریخ های مورد نظر را انتخاب کنید", iSsuccess: false });
      
              }  else */
      if (_.isUndefined(data.amusementserviceList) || _.isEmpty(data.amusementserviceList)) {
        SwalMessage({ title: "لطفا تفریحات مورد نظر را انتخاب کنید", iSsuccess: false });

      } else if (_.isUndefined(data.amusementserviceListId) || _.isEmpty(data.amusementserviceListId)) {
        SwalMessage({ title: "لطفا یکی از موارد تفریح مورد نظر را  به جهت درج یا حذف اطلاعات از لیست درختی انتخاب کنید", iSsuccess: false, timer: 25000 });

      }

      else {

        let response = await ApiAmusementService.customDateInjection(data);
        if (response.succeeded === true)
          SwalMessage({ title: "اطلاعات با موفقیت ثبت شد", iSsuccess: true });
        else
          SwalMessage({ title: response.message, iSsuccess: false });



      }







    } catch (error) {
      console.log("error=", error);
    }
  };

  function handleChangeMulti(event) {
    setValue("amusementserviceList", event);
    let reserveDetails = [];
    var tt = event?.map((item) => {
      let res = allAmusementServiceList?.find((e) => e.id === item.value);
      if (!_.isEmpty(res)) reserveDetails.push(JSON.parse(res.reserveDetails))

    })
    setTreeViewData(reserveDetails);



  }
  const selectStyles = {

    menu: base => ({
      ...base,
      zIndex: 10000
    })
  }

  StyledTreeItem.propTypes = {
    // bgColor: PropTypes.string,
    // color: PropTypes.string,
    labelIcon: PropTypes.elementType.isRequired,
    labelInfo: PropTypes.string,
    labelText: PropTypes.string.isRequired,
  };
  const useTreeItemStyles = styled((theme) => ({
    root: {
      color: theme.palette.text.secondary,
      '&:hover > $content': {
        backgroundColor: theme.palette.action.hover,
      },
      '&:focus > $content, &$selected > $content': {
        backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
        color: 'var(--tree-view-color)',
      },
      '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
        backgroundColor: 'transparent',
      },
    },
    content: {
      color: theme.palette.text.secondary,
      borderTopRightRadius: theme.spacing(2),
      borderBottomRightRadius: theme.spacing(2),
      paddingRight: theme.spacing(1),
      fontWeight: theme.typography.fontWeightMedium,
      '$expanded > &': {
        fontWeight: theme.typography.fontWeightRegular,
      },
    },
    group: {
      marginLeft: 0,
      '& $content': {
        paddingLeft: theme.spacing(2),
      },
    },
    expanded: {},
    selected: {},
    label: {
      fontWeight: 'inherit',
      color: 'inherit',
    },
    labelRoot: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0.5, 0),
    },
    labelIcon: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
    },
    // labelText: {
    //   fontWeight: 'inherit',
    //   flexGrow: 1,
    // },
  }));
  function StyledTreeItem(props) {
    const classes = useTreeItemStyles();
    const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, ...other } = props;

    return (
      <TreeItem
        label={

          <div className={classes.labelRoot}>
            <LabelIcon color="inherit" className={classes.labelIcon} />
            <Typography variant="body2" className={classes.labelText}>
              {labelText}
            </Typography>
            <Typography variant="caption" color="inherit">
              {labelInfo}
            </Typography>
          </div>
        }

        {...other}
      />
    );
  }

  //node is always the root "Parent"
  //id is id of node clicked
  function getChildById(node, id) {
    let array = [];

    //returns an array of nodes ids: clicked node id and all children node ids
    function getAllChild(nodes) {
      if (nodes === null) return [];
      array.push(nodes.Id);
      if (Array.isArray(nodes.Child)) {
        nodes.Child.forEach((node) => {
          array = [...array, ...getAllChild(node)];
          array = array.filter((v, i) => array.indexOf(v) === i);
        });
      }
      return array;
    }

    //returns the node object that was selected
    function getNodeById(nodes, id) {
      if (nodes.Id === id) {
        return nodes;
      } else if (Array.isArray(nodes.Child)) {
        let result = null;
        nodes.Child.forEach((node) => {
          if (!!getNodeById(node, id)) {
            result = getNodeById(node, id);
          }
        });
        return result;
      }

      return null;
    }

    return getAllChild(getNodeById(node, id));
  }

  function getOnChange(checked, nodes) {
    //gets all freshly selected or unselected nodes
    const allNode = getChildById(nodes, nodes.Id);
    //combines newly selected nodes with existing selection
    //or filters out newly deselected nodes from existing selection
    let array = checked
      ? [...selected, ...allNode]
      : selected.filter((value) => !allNode.includes(value));

    setSelected(array);

  }
  const RenderTreeWithCheckboxes = (nodes) => {
    // return (
    //   <TreeItem
    //     key={nodes.Id}
    //     nodeId={nodes.Id}
    //     label={nodes.Type != "Text" ?
    //       <FormControlLabel
    //         control={
    //           <Checkbox
    //             id={_.toString(nodes.Id)}
    //             name={"checkBox" + nodes.Id}
    //             {...register("checkBox" + nodes.Id)}
    //             checked={selected.some((item) => item === nodes.Id)}
    //             onChange={(event) =>
    //               getOnChange(event.currentTarget.checked, nodes)
    //             }
    //             //onClick={(e) => e.stopPropagation()}
    //             className={classes.checkbox}
    //           />


    //         }
    //         label={<>{nodes.Text}</>}
    //         key={nodes.Id}
    //       /> : nodes.Text
    //     }
    //   >
    //     {Array.isArray(nodes.Child)
    //       ? nodes.Child.map((node) => RenderTreeWithCheckboxes(node))
    //       : null}
    //   </TreeItem>
    // );
  };
  //ساخت درخت سرویس
  // const renderTree = (nodes) =>
  // (

  //   //برای چک خوردن دکمه رادیو از RadioButtonCheckedIcon استفاده شود
  //   //برای چک خوردن دکمه چک باکس از CheckBoxIcon استفاده شود
  //   (nodes != null) ? <>
  //     <TreeView
  //       defaultCollapseIcon={<ExpandMoreIcon />}
  //       defaultExpanded={["0", "3", "4"]}
  //       defaultExpandIcon={<ChevronRightIcon />}
  //     >
  //       {RenderTreeWithCheckboxes(nodes)}
  //     </TreeView></> : "آیتمی برای نمایش موجود نمی باشد"



  // );
  const handleChange = (selectedOption) => {
    // let groupedOptions = {
    //   label: "Colours",
    //   options: colourOptions
    // };


  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5 ">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              مدیریت تاریخ سرویس
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              افزودن یا ویرایش تاریخ های فعال/غیرفعال تفریحات
            </span>
          </h3>
        </div>
        {/*Start body */}
        <form onSubmit={handleSubmit(onSubmit)} >
          <div className="card-body pt-3 pb-0 border-top px-1">
            <Row>
              <Col sm="12" lg="6" xs="12">
                <Col xs="12" sm="6" lg="8">   <h6 className="my-3">  لطفا تاریخ های مورد نظر را انتخاب نمایید:</h6>    </Col>
                <Col xs="12" sm="6" lg="8" className="px-0 mx-auto ">
                  <Controller
                    name="selectedDates"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Calendar
                        value={value}
                        onChange={onChange}
                        plugins={[weekends()]}
                        calendar={persian}
                        locale={customLocale}
                        minDate={getValues("minimumDate")}
                      />
                    )}
                  />
                </Col>
                <div className="py-5 my-5 rounded px-2 mx-5 d-flex" style={{ backgroundColor: "#ffe9a9" }}>
                  <Col lg="1" xs="1" className="my-auto">
                    <i className="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
                  </Col>
                  <Col lg="10" xs="10">
                    <p className="mb-0">
                      در صورت عدم انتخاب تاریخ و انتخاب گزینه "حذف شود" تاریخ های درج شده ی قبلی در سرویس های انتخاب شده به طور کامل حذف می شود
                    </p>
                  </Col>
                </div>
              </Col>
              <Col xs="12" sm="12" lg="6">
                <Col xs="12" className="my-4">
                  <h6 className="my-3">  لطفا تفریحات مورد نظر را انتخاب  نمایید:</h6>
                  <Controller
                    name="amusementserviceList"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        styles={selectStyles}
                        inputId="react-select-multiple"
                        clearOnSelect={false}
                        TextFieldProps={{
                          label: "Countries",
                          InputLabelProps: {
                            htmlFor: "react-select-multiple",
                            shrink: true,
                          },
                          placeholder: "Select multiple countries",
                        }}
                        // options={allAmusementServiceList?.map((item) => (
                        //  {
                        //   value: item.id,
                        //   label: item.name,
                        //   serviceId : JSON.parse(item.reserveDetails)?.Id
                        // }
                        //))}
                        options={groupByAmuzmentService}
                        value={value || ""}
                        inputValue={inputValue}
                        //blurInputOnSelect={false} 
                        closeMenuOnSelect={false} //prevents menu close after select, which would also result in input blur
                        onChange={handleChangeMulti}
                        label="انتخاب تفریحات"
                        isMulti
                        filterOption={filterOption}
                        onInputChange={onInputChange}
                      //isClearable
                      //isSearchable
                      />

                    )}
                  />
                </Col>
                {!_.isEmpty(treeViewData) && <>  <h6 className="mt-5 mx-3">   لطفا به جهت درج تاریخ از لیست زیر آیتم های مورد نظر رو انتخاب کنید:</h6>

                  <Col xs="12">
                    {/* <TreeView
                      className={classes.root}
                      defaultCollapseIcon={<IndeterminateCheckBoxIcon />}
                      defaultExpanded={['root']}
                      defaultExpandIcon={<AddBoxIcon />}
                    >
                      {treeViewData.map((item) => renderTree(item))
                      }
                    </TreeView> */}

                  </Col></>}

                <Col xs="12" sm="12" lg="12" className="mb-5">
                  <Controller
                    name="description"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="توضیحات"
                        type="text"
                        rows={10}
                        multiline
                        variant="outlined"
                        margin="normal"

                        // placeholder="توضیحات"
                        value={value || ""}
                        onInput={onChange}
                        sx={{
                          ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                            padding: "8.5px 14px 8.5px 0px !important",
                          }
                        }}
                      />
                    )}
                  />
                </Col>
                <Col xs='12' sm="12" lg="12">
                  <FormControlLabel
                    control={
                      <Controller
                        control={control}
                        name={"noService"}
                        render={({ field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }

                    label="عدم سرویس دهی ، با انتخاب این گزینه تفریحات انتخابی شما برای تاریخ های انتخاب شده غیر فعال می شود."
                  />

                </Col>
                <Col xs='12' sm="12" lg="12">
                  <FormControlLabel
                    control={
                      <Controller
                        control={control}
                        name={"removeRules"}
                        render={({ field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="حذف شود ، با انتخاب این گزینه اطلاعات مربوط به سرویس دهی  تفریحات انتخابی شما در تاریخ های وارد شده حذف می شود  "

                  />
                  {/*    <span className={useStyles.text}>
                                    در صورت عدم انتخاب تاریخ و انتخاب این گزینه کلیه تاریخ های درج شده از قبل به صورت کامل در هر آیتم حذف می شود
                                    </span> */}

                </Col>
              </Col>
            </Row>
          </div>
          <div className="card-footer">
            <Button variant="success" type="submit" disabled={isSubmitting} className='w-100'>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Link className="btn btn-danger ml-3" to="/amusementService">
              <CloseIcon /> بازگشت
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};
export default CreateEditAmusementServiceDate;
